import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import SystemClient from './system/SystemClient';
import Environment from './lib/Environment';
import MessageCourier from './lib/MessageCourier';
import AppInRouterContext from './AppInRouterContext';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { getTheme } from '@fluentui/react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { createTheme, ThemeProvider } from '@fluentui/react';
import UpdateNoticeDialog from './components/Common/UpdateNoticeDialog';

const environment = new Environment();
const system = SystemClient.start(environment);
const appMessageCourier = new MessageCourier();

initializeIcons();

const theme = createTheme({
  components: {
    TextField: {
      styles: {
        field: {
          fontSize: '16px',
        },
      },
    },
  },
});

interface IApp {
  newVersionAvailable: boolean;
  onUpdateVersion: () => void;
}

const App = (props: IApp) => {
  return (
    <React.Fragment>
      {system && (
        <GoogleReCaptchaProvider
          reCaptchaKey={environment.captchaKey()}
          language={'es'}
          scriptProps={{ async: false, appendTo: 'head' }}
        >
          <ThemeProvider theme={theme} style={{ height: '100%', overflow: 'hidden' }}>
            <BrowserRouter basename={environment.getLocalBasePath()}>
              {props.newVersionAvailable && (
                <UpdateNoticeDialog
                  showDialog={props.newVersionAvailable}
                  toggleShowDialog={() => props.onUpdateVersion()}
                  onAccept={() => props.onUpdateVersion()}
                  onCancel={() => props.onUpdateVersion()}
                  hideCancelButton={true}
                ></UpdateNoticeDialog>
              )}

              <AppInRouterContext system={system} environment={environment} courier={appMessageCourier} />
            </BrowserRouter>
          </ThemeProvider>
        </GoogleReCaptchaProvider>
      )}
    </React.Fragment>
  );
}

export default App;
